/**
 * True when the profile response marks the user as a shadow user.
 * @param {object} userDetails - profile response data
 * @returns {boolean}
 */
export const isShadowUser = (userDetails) =>
  userDetails?.isShadowUser === true ||
  String(userDetails?.isShadowUser ?? "").toUpperCase() === "YES";

/**
 * Email to send to the data APIs: shadow users act as their parent, everyone else uses their own email.
 * @param {object} userDetails - profile response data
 * @returns {string|undefined}
 */
export const getEffectiveEmail = (userDetails) => {
  const parentEmail = String(userDetails?.parentEmail ?? "").trim();
  return isShadowUser(userDetails) && parentEmail ? parentEmail : userDetails?.email;
};
